<section class="not-found-container">
  <img
    [src]="'/pia/assets/404banner.png'"
    [alt]="'pia.shared.notFoundImageAltDescription' | translate"
    class="banner-image"
  />
  <div class="not-found-info">
    <h1 class="not-found-title font-3xl">Page not found</h1>
    <p class="not-found-text font-m">The requested page could not be found.</p>
    <p class="not-found-text font-m">Please go directly to the home page.</p>
  </div>
  <a class="not-found-link font-m" routerLink="/pia">
    <img src="/pia/icons/vector.svg" alt="" class="vector-image" />
    Back to dashboard
  </a>
</section>
